module.exports = __webpack_public_path__ + "static/favicon.89c5e15c.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = ./src/assets/favicon.ico
// module chunks = 114276838955818